import { useLocation } from '@reach/router'
import React from 'react'

import Footer from '../Footer'
import FooterTelesales from '../FooterTelesales'
import PreFooter from '../PreFooter'

export const CommonFooterRender = () => {
  const location = useLocation()
  const isTelesalesLocation = location.pathname.includes('/vendas-whatsapp')

  if (isTelesalesLocation) {
    return <FooterTelesales />
  }

  return (
    <>
      <PreFooter />
      <Footer />
    </>
  )
}

export default CommonFooterRender
